/**
 * Encabezado de columna ordenable. `sort` = { key, dir }; al click llama
 * `onSort(sortKey)` (el padre alterna desc/asc). Muestra la flecha en la
 * columna activa.
 */
export default function SortHeader({ children, sortKey, sort, onSort, align = 'right' }) {
  const active = sort.key === sortKey;
  return (
    <th className={`px-3 py-2 font-medium ${align === 'left' ? 'text-left' : 'text-right'}`}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={`inline-flex items-center gap-1 hover:text-gray-700 ${active ? 'text-gray-900' : ''}`}
      >
        {children}
        {active && <span aria-hidden="true">{sort.dir === 'desc' ? '▾' : '▴'}</span>}
      </button>
    </th>
  );
}
